export type Option<T> = { kind: 'none', } | { kind: 'some', value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value,
  }
}

export function toRelativeUrl(url: string): string {
  return url.replace(`${window.location.protocol}//${window.location.host}`, '')
  .replace('https://conneqt-hypotrust-website.test.viddadigital.com','')
}

export function urlIsExternal(url: string): boolean {
  return url.startsWith('http') && !url.startsWith(`${window.location.protocol}://${window.location.host}`)
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export type LoadState<T> = {
  kind: 'loading'
} | {
  kind: 'error'
  errors: {
    [key: string]: string
  }
} | {
  kind: 'loaded'
  data: Option<T>
}


export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url;
}

export function upperCaseFirst(text: string): string {
  return text ? text.substring(0, 1).toUpperCase() + text.substring(1) : ''
}


// WEBPACK FOOTER //
// ./Client/utils.ts